import axios from 'axios';
import {useTranslation} from 'react-i18next';
import {useLoaderData} from 'react-router-dom';
import HeaderWithIcons from '@components/app/HeaderWithIcons';
import Banner from '../uikit/Banner';
import {ICompetitionCategory} from './ICompetitions';
import {appConfig} from '@config';
import CustomCard from '@components/uikit/Card';
import {Box, Typography} from '@mui/material';

export default function CompetitionsCategories() {
	const categories = useLoaderData() as ICompetitionCategory[];
	const {t} = useTranslation();
	return (
		<>
			<HeaderWithIcons title={t('competitions.title')}/>
			{/*<Box>*/}
			{/*	<div className="flex flex-col space-y-2 px-4">*/}
			{/*		{*/}
			{/*			categories ?*/}
			{/*				categories.map(category => <Banner*/}
			{/*					key={category.id}*/}
			{/*					title={category.name}*/}
			{/*					image={category.image}*/}
			{/*					url={`/competitions/${category.id}`}*/}
			{/*					state={category}/>)*/}
			{/*				: ''*/}
			{/*		}*/}
			{/*	</div>*/}
			{/*</Box>*/}
			
			<Box className="flex flex-col space-y-2 px-4">
				{
					categories.length > 0 ?
						categories.map(category => <CustomCard
							key={category.id}
							title={category.name}
							image={category.image}
							url={`/competitions/${category.id}`}
							state={category}/>)
						: <Typography sx={{color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100'}}
						              className="grow w-full text-center font-bold">{t('competitions.empty')}</Typography>
				}
			</Box>
		</>
	);
}

interface loader {
	request: Request;
	params: {};
}

export async function competitionsCategoriesLoader(data: loader) {
	try {
		const res = await axios({
			url: `${appConfig.competition2.url}categories`,
			method: 'GET'
		});
		if (res.data.success) {
			return res.data.result;
		} else {
			return res.data.error;
		}
	} catch (err){
		return [];
	}
}
